import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import type { TimeInsightsEntitiesClockInStatusStatusEnum } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import { getStatusBadge } from './utils'

interface Props {
  employeeFullName: string
  employeeAvatar: string
  status: TimeInsightsEntitiesClockInStatusStatusEnum
  onClick: () => void
}

const ListContent = ({ onClick, employeeFullName, employeeAvatar, status }: Props) => {
  const badge = getStatusBadge(status)

  return (
    <Box onClick={onClick} flexDirection="row" alignItems="center" overflowY="hidden" gap="s12">
      <Box flexNoShrink>
        <Avatar size="s40" url={buildUrl(employeeAvatar)} label={employeeFullName} badge={badge} />
      </Box>
      <Box flexGrow flexDirection="row" alignItems="center">
        <Text.Normal color="grey1000" weight="medium" size="300" ellipsis>
          {employeeFullName}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default ListContent
